import React, { Component } from 'react';
import { connect } from 'react-redux';

import MagazineItem from '../magazine/magazine-item';

class FeaturedTop extends Component {

	getFeaturedRow() {
		if ( this.props.featured.length ) {
			//why are 0 and 1 indexes duplicate posts?
			return this.props.featured.splice( 1, 4 ).map( ( post, i ) => {
				return (
					<MagazineItem post={ post } ind={ i } classes="excerpt-small post" key={ post.id } />
				);
			} );
		} else {
			return [ 0, 1, 2, 3 ].map( i => this.getEmptyRow( i ) );
		}
	}

	getEmptyRow( i ) {
		return (<div className="col-sm-6 col-lg-3 react-placeholder cat-stickies" key={ i }>
				<article className="excerpt-small post">
					<header className="entry-header">
						<h2 className="entry-title">
							&nbsp;
						</h2>
					</header>
				</article>
			</div>
		);
	}

	render() {
		return (
			<div className="related-posts category-featured row 112">
				<div className="row-four-column col-xs-12">
					<div className="row no-gutter">
						{ this.getFeaturedRow() }
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps( { featured } ) {
	return { featured };
}

export default connect( mapStateToProps )( FeaturedTop );